import React, { useEffect, useState } from "react";
import "react-calendar/dist/Calendar.css";
import MakeItemField from "utils/MakeItemField";
import HideCard from "./HideCard";
import { isEmpty } from "js/common";

/* 데이터 테이블 검색 */
// export default function SearchList({ conditionList, onSearch, initialData, radio, radioResult }) {
export default function SearchList({ conditionList, onSearch, initialData, onChangeCondition}) {
    const [searchData, setSearchData] = useState({});
    const [searchDisabled, setSearchDisabled] = useState(false);

	let hideCardCssName = "";
	conditionList.forEach((condition) => {
		if(condition?.type.includes("dayPicker") || condition?.type.includes("yearPicker")) {
			hideCardCssName = "datePicker";
		}
	})


    //상태 첫번째 값을 검색어에 넣어주는 함수
    function extractOptionValue(data) {
        for (const item of data) {
            if (item?.option) {
                const firstValue = item.option[0].value;
                return { col: item.col, value: firstValue };
            }
        }
        return null;
    }
    const optionData = extractOptionValue(conditionList);
    useEffect(() => {
        if (optionData) {
            setSearchData({ [optionData.col]: optionData.value });
        }
    }, []);

    /* 검색 이벤트 */
    const searchClick = () => {
        Object.keys(searchData).forEach((key) => {
            if (searchData[key] === "") {
                delete searchData[key]; //빈값 제외
                // setNameOfButton("refresh");
            }
        });
        onSearch && onSearch(searchData);
        //setInitialData({}); //초기화
    };

    /* 검색 데이터 */
    const onChange = (value) => {
        setSearchData((prevData) => {
            return { ...prevData, ...value };
        });
		onChangeCondition && onChangeCondition(value);
    };

    return (
        <>
            <HideCard title="검색 조건" color="back-lightgreen" className={ `mg-b-40 ${hideCardCssName}` } style={{ position: "relative", zIndex: "999" }}>
                <div className="flex-container searchCondition">
                    {conditionList.map((param, idx) => {
						if(param === null || isEmpty(param)) {
							return "";
						}
						return (
                        <div key={idx} className={`flex-group mg-b-10 ${param.sizeClass ?? ""}`} style={{display : "flex"}}>
                            <div className="flex-label" style={{...param.titleStyle ?? ""}}>
                                <label>{param.title}</label>
								{param.required && <span className="burgundy">*</span>}
                            </div>
                            <div className="flex-input">
                                <MakeItemField item={param} resultData={onChange} setSearchDisabled={setSearchDisabled} initialData={initialData} onEnterDown={() => searchClick()} />
                            </div>
                            
                        </div>
                    )})}
                </div>
                <div style={{ textAlign: "right" }}>
                    <button className="table-btn btn-search" onClick={searchClick} disabled={searchDisabled}>
                        검색
                    </button>
                </div>
            </HideCard>
        </>
    );
}
